export const labelCropStepper =
    {
        "labelChooseCrop": {
            "en": "Choose a crop",
            "es": "Elige un cultivo",
            "fr": "Choisissez une culture",
            "pt": "Escolha uma colheita",
            "ru": "Выберите урожай",
            "zh": "Choose a crop"
        },
        "labelYieldGoal": {
            "en": "Yield Goal",
            "es": "Rendimiento Objetivo",
            "fr": "Rendement objectif",
            "pt": "Produtividade almejada",
            "ru": "Планируемая урожайность",
            "zh": "目标产量"
        },
        "labelViewResult": {
            "en": "View Result",
            "es": "Ver resultado",
            "fr": "Voir résultat",
            "pt": "Ver resultado",
            "ru": "Посмотреть результат",
            "zh": "查看结果"
        },
        "labelButtonBack": {
            "en": "Back",
            "es": "Previo",
            "fr": "Arriéré",
            "pt": "Prévio",
            "ru": "назад",
            "zh": "背部"
        },
        "labelButtonNext": {
            "en": "Next",
            "es": "Próximo",
            "fr": "Prochain",
            "pt": "Próximo",
            "ru": "следующий",
            "zh": "下一个"
        },
        "labelButtonFinished": {
            "en": "Finished",
            "es": "Terminada",
            "fr": "Finie",
            "pt": "Acabado",
            "ru": "Законченный",
            "zh": "已完成"
        },
        "labelButtonNew": {
            "en": "New",
            "es": "Nueva",
            "fr": "Nouvelle",
            "pt": "Nova",
            "ru": "новый",
            "zh": "新"
        }
    };
